<template>
  <div class="inquiryWrapper">
    <div class="title">{{$t('other.a1076')}}</div>
    <div>
      <el-table ref="multipleTable" border :data="orderList" >
				<el-table-column :label="$t('other.a1898')" width="180" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.createUserId}}</span>
					</template>
				</el-table-column>
        <el-table-column :label="$t('other.a587')" width="100" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.qty}}</span>
					</template>
				</el-table-column>
        <!-- <el-table-column :label="$t('other.a817')" width="100" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.skus}}</span>
					</template>
				</el-table-column> -->
        <el-table-column label="SKU" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.variationName}}</span>
					</template>
				</el-table-column>
        <el-table-column :label="$t('other.a834')" width="100" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.totalAmount}}</span>
					</template>
				</el-table-column>
        <el-table-column label="whatsapp" width="100" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.whatsapp}}</span>
					</template>
				</el-table-column>
        <el-table-column :label="$t('other.a1899')" width="200"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{getTime01(scope.row.updateTime)}}</span>
					</template>
				</el-table-column>
			</el-table>
    </div>
    <!-- 分页器 -->
		<!-- <div class="Pager">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="[10,20,50,100]" :page-size="offset" layout="total, sizes, prev, pager, next, jumper" :total="Total">
			</el-pagination>
		</div> -->
  </div>
</template>

<script>
import api from "../../api/moudles/distribution";
import utils from '../../utils/utils.js'
export default {
  data() {
    return {
      dataParams: {
        pageNum: 1,
        pageSize: 100,
        partnerId: 0,
        type: 2,
        userId: ""
      },
      userInfo:null,
      orderList:[],
      Total:0
    };
  },
  created() {
    this.userInfo=JSON.parse(localStorage.getItem('userInfo'))
    this.dataParams.userId=this.userInfo.userId || ''
    this.getData()
  },
  methods: {
    getData() {
      api.getInquiryOrder(this.dataParams).then(res => {
        if (res.code === 200) {
          this.orderList=res.data.inquiryOrders
          this.orderList.forEach(p => {
            p.qty=0
            p.skus=''
            p.variationName=''
            p.items.forEach(i => {
              p.qty += i.amount
              p.skus += i.userStoreItem.skuName + '/'
              p.variationName  += i.userStoreItem.variationName + '/'
            })
          })
          console.log("desc", res.data);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    getTime01(time) {
				return utils.renderTime(time)
			
			},
  }
};
</script>
<style lang="scss" scoped>
.inquiryWrapper{
  .title{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

    .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
}
</style>